import TeamStepOne from './TeamStepOne'
import TeamStepTwo from './TeamStepTwo'
import {LinkDashboardModal} from './TeamStepThree'
import {ReviewStep} from './ReviewStep'

/**
 * Config for Team Dashboard Onboarding Steps
 * Each step specifies the component to render and optional label/description.
 */
const teamStepConfig = [
  {
    label: 'General Information',
    description: 'Please provide the required information',
    component: TeamStepOne,
    getProps: (props: any) => ({
      values: props.values,
      errors: props.errors,
      touched: props.touched,
      onChange: props.onChange,
      onBlur: props.onBlur,
      onTeamNameError: props.onTeamNameError,
      editMode: props.editMode,
    }),
  },
  {
    label: 'Section Details',
    description: 'Please add the section(s) and provide the required information',
    component: TeamStepTwo,
    getProps: (props: any) => ({
      values: props.values,
      errors: props.errors,
      touched: props.touched,
      setWidgetConfigErrors: props.setWidgetConfigErrors,
      onboardingDashboard: props.onboardingDashboard,
      dispatch: props.dispatch,
    }),
  },
  {
    label: 'Assign Program Dashboard',
    description: 'Please select an option from the dropdown below.',
    component: LinkDashboardModal,
    getProps: (props: any) => ({
      values: props.values,
      errors: props.errors,
      touched: props.touched,
      productId: props.productId,
      setProductId: props.setProductId,
      setStep: props.setStep,
      onProductIdChange: props.onProductIdChange,
    }),
  },
  {
    label: 'Review',
    description: 'Please review the information before submitting',
    component: ReviewStep,
    getProps: (props: any) => ({
      isDark: props.isDark,
      onEditStep: props.setStep,
    }),
  },
]

export default teamStepConfig
